// Auth guard — redirects unauthenticated users to /login.
// Passes the current path as `returnTo` so LoginPage can redirect back after login.
// Full auth flow (refresh on mount, session expiry) implemented in F15 (Task 122).

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../stores/authStore';
import LoadingOverlay from '../shared/components/common/LoadingOverlay';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

function ProtectedRoute({ children }: ProtectedRouteProps): React.ReactElement {
  const { isAuthenticated, isInitializing } = useAuth();
  const location = useLocation();

  // AuthInitializer is attempting a silent token refresh — hold routing until done.
  if (isInitializing) {
    return <LoadingOverlay />;
  }

  if (!isAuthenticated) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;
